import React from 'react';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import { defineMessage, useIntl } from '@atlassian/jira-intl';

const loadingMessage = defineMessage({
	id: 'help-center-management-settings-skeleton.loading',
	defaultMessage: 'Loading help center settings',
	description: 'Accessible label for the help center settings loading skeleton.',
});

export const HelpCenterManagementSettingsSkeleton = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Box padding="space.400" role="status" aria-label={formatMessage(loadingMessage)}>
			<Stack space="space.300">
				<Stack space="space.200">
					<Inline space="space.100">
						<Skeleton width="80px" height="16px" isShimmering />
						<Skeleton width="160px" height="16px" isShimmering />
					</Inline>
					<Skeleton width="240px" height="32px" isShimmering />
					<Stack space="space.050">
						<Skeleton width="100%" height="20px" isShimmering />
						<Skeleton width="65%" height="20px" isShimmering />
					</Stack>
				</Stack>
				<Inline space="space.200">
					<Skeleton width="64px" height="24px" isShimmering />
					<Skeleton width="64px" height="24px" isShimmering />
					<Skeleton width="96px" height="24px" isShimmering />
				</Inline>
				<Skeleton width="100%" height="480px" borderRadius={token('radius.medium')} isShimmering />
			</Stack>
		</Box>
	);
};
